import { Link } from "react-router-dom";
import { ArrowRight, Check, X } from "lucide-react";
import { fmtTime } from "@/lib/api";

export function SetResults({ day, totalDays, results, todayScore, responseMs }) {
  return (
    <div className="fade-up" data-testid="set-results">
      <p className="eyebrow">Day {day} of {totalDays} · Submitted</p>
      <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight">Set complete.</h1>
      <div className="mt-5 grid grid-cols-2 gap-3">
        <div className="panel p-5"><p className="eyebrow">Today's score</p><p className="mt-2 font-mono text-3xl font-bold text-emerald-400" data-testid="set-today-score">{todayScore}</p></div>
        <div className="panel p-5"><p className="eyebrow">Time taken</p><p className="mt-2 font-mono text-3xl font-bold text-white" data-testid="set-time-taken">{fmtTime(responseMs)}</p></div>
      </div>
      <ul className="panel mt-3 divide-y divide-slate-800" data-testid="set-results-list">
        {results.map((r) => (
          <li key={r.challenge_number} className="flex items-center gap-3 px-5 py-3.5" data-testid={`set-result-${r.challenge_number}`}>
            <span className={`grid h-8 w-8 place-items-center rounded-full ${r.is_correct ? "bg-emerald-500 text-slate-950" : "bg-rose-500 text-white"}`}>{r.is_correct ? <Check size={16} strokeWidth={3} /> : <X size={16} strokeWidth={3} />}</span>
            <span className="flex-1 text-sm font-medium">Challenge {r.challenge_number}</span>
            <span className={`font-mono text-sm font-bold ${r.is_correct ? "text-emerald-400" : "text-rose-400"}`}>+{r.points_awarded} / {r.points}</span>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-slate-500">Answers are never revealed. Your time counts as the leaderboard tiebreaker.</p>
      <Link to="/result" className="btn-primary mt-6 w-full" data-testid="set-results-next-button">See today's result <ArrowRight size={18} /></Link>
    </div>
  );
}
